<template lang="pug">
	.v-section-table.section-table(v-if="data")
		.section-table__container.container
			.section-table__wrap
				h2.section-table__title(v-if="data.title" v-html="data.title")

				.section-table__table-wrap.no-scroll(v-if="data.table && data.table.src")
					img.section-table__table-image(:src="data.table.src" alt="")
</template>

<script>
import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>